import { Validator, ValidationResult, ValidatorOptions } from "./Index";
import i18n from '../helpers/i18n';

export function minlength(minLength: number, options: ValidatorOptions = new ValidatorOptions()): Validator {
    return {
        options: options,
        validate: (value: any) => {

            const result = {
                hasError: (value || '').length < minLength,
                errorMessage: options.errorMessage
                    ? options.errorMessage
                    : i18n.t('Minlength', { minLength: minLength })
            } as ValidationResult;

            return result;
        }
    }
};
